export default __webpack_public_path__ + "assets/images/71d4fd83c98417b71b493fe2ff4e7e38.jpg";